// Settings — signed-in user settings: the Security section (passkey
// enrolment + management) for everyone, and the operator Alerts card for
// platform admins. Rendered inside the authed App shell.
import { AlertsCard } from "@/components/AlertsCard";
import { PasskeySection } from "@/components/PasskeySection";
import { useAuth, effectiveRole, isAdminRole } from "@/store/auth";

export function Settings() {
  const role = useAuth((s) => effectiveRole(s));
  return (
    <div className="page" style={{ padding: 24 }}>
      <header style={{ marginBottom: 16 }}>
        <div className="eyebrow">Settings</div>
        <h1
          style={{
            fontFamily: "var(--font-serif, 'Instrument Serif', serif)",
            fontSize: 28,
            margin: "4px 0",
          }}
        >
          Account &amp; security
        </h1>
        <p className="dim" style={{ fontSize: 13, maxWidth: 720 }}>
          Manage the passkeys you use to sign in. A passkey lets you access the
          console with your fingerprint, face, or device PIN instead of an email
          code.
        </p>
      </header>

      <PasskeySection />

      {/* Admin-only: the backend 403s the routes for anyone else, and a
          merchant user has no rails of their own to be alerted about. */}
      {isAdminRole(role) && <AlertsCard />}
    </div>
  );
}
